import { Outlet, createFileRoute } from "@tanstack/react-router";
import { metaAtom } from "atoms/metaAtom.ts";
import { AccountLayout } from "components/Layouts/AccountLayout/AccountLayout.tsx";
import { getSessionFromStorage, useSession } from "hooks/useSession.ts";
import { useUser } from "hooks/useUser.ts";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useRecoilValue } from "recoil";

export const Route = createFileRoute("/_authenticated/account/_layout")({
    component: AccountLayoutComponent,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("common.account"),
    }),
});

function AccountLayoutComponent() {
    const sessionUtils = useSession();
    const userUtils = useUser();
    const metaState = useRecoilValue(metaAtom);

    const [isInitialized, setInitialized] = useState(false);

    useEffect(() => {
        const { user } = getSessionFromStorage();
        if (user) {
            sessionUtils.setUser(user);
        }
        userUtils.setTenant(null);
        setInitialized(true);
    }, []);

    if (!isInitialized) {
        return null;
    }

    return (
        <>
            <Helmet title={metaState.title} />
            <AccountLayout>
                <Outlet />
            </AccountLayout>
        </>
    );
}
